export interface MultiplePersonalizationEngineRequest {
  userdata: Partial<UserData>;
  requestparam: RequestParam;
}

export interface UserData {
  membershipLevel: string;
  amexCardMember?: string;
  usResident?: string;
  ageRestrict?: string;
  birthDay?: boolean;
  sevenDaysBeforeBirthday?: boolean;
  sevenDaysAfterBirthday?: boolean;
  mqdValue?: number;
  internationalUser?: boolean;
  skyMilesAnniversary?: boolean;
  mqdPercent?: number;
  availableMiles?: number;
  profileSetUp?: boolean;
  newJoiner?: boolean;
  rollover?: string;
  currentDate?: string;
  presentDate?: string;
  downgradeTier?: boolean;
  skyclub?: boolean;
}

export interface RequestParam {
  campaignId: string | string[];
  format: string;
}

export interface OfferCards {
  cards: string[];
}

export interface ParsysPromotionalCards {
  promotional_cards: OfferCards;
}

export interface OfferAmexBanner {
  cardType?: string;
  description: string;
  termsCTA: string;
  headline: string;
  termsLabel: string;
  termsId: string;
  learnMoreCTA: string;
  cardImage: string;
  title: string;
  learnMoreLabel: string;
  learnMoreId: string;
}

export interface ParsysAmexBanner {
  amexbanner: OfferAmexBanner;
}

export interface PEMicroMoment {
  description?: string;
  logoAltText: string;
  microMomentType: string;
  closePath: string;
  title: string;
  actionUrl?: string;
  logoImageUrl: string;
  logoLabelTitle?: string;
  logoLabelSubTitle?: string;
  ariaLabelClose: string;
  actionLabel?: string;
  tagTitle?: string;
  tagSrc?: string;
  tagAlt?: string;
  closeAltText: string;
}

export interface PEOnboarding {
  microMomentType: string;
  closePath: string;
  subtitle: string;
  label: string;
  closeAltText: string;
  closeAriaLabel: string;
  title: string;
  items: string[];
}

export interface ParsysMicroMoments {
  micromoments?: PEMicroMoment;
  onboardingmodal?: PEOnboarding;
}

export interface ParsysOnboarding {
  onboardingmodal: PEOnboarding;
}

export interface MainObject {
  'jcr:description'?: string[];
  minimumStay?: string;
  'cq:segments'?: string[];
  skyMilesTier?: string;
  analyticsPageName?: string;
  alertLevel?: string;
  teaserCampaign?: string[];
}

export interface AmexStaticBanners extends MainObject {
  parsys: ParsysAmexBanner;
}

export interface PromotionalCards extends MainObject {
  parsys: ParsysPromotionalCards;
}

export interface MicroMoments extends MainObject {
  parsys: ParsysMicroMoments;
}

export interface MultiplePersonalizationEngineResponse {
  'ng-skymiles:promotional-cards': PromotionalCards;
  'ng-skymiles:amex-banners': AmexStaticBanners;
  'ng-skymiles:micro-moments-v1': MicroMoments;
}

export interface AEMOffer {
  id: string;
  type: string;
  headline: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaURL: string;
  ctaType: string;
  image_1: string;
  image_2: string;
  image_3: string;
  image_4: string;
}

export interface OnboardingContent {
  description: string;
  linkLabel: string;
  linkUrl: string;
  logoAlt: string;
  logoSrc: string;
  mobileAndroid: string;
  mobileIos: string;
  title: string;
}
